export const StatusComandaItem = {
  Aberto: 0,
  ParcialmentePago: 1,
  Fechado: 2,
  Cancelado: 3
};


export const StatusComandaItemDescricao = {
  [StatusComandaItem.Aberto]: "Aberto",
  [StatusComandaItem.ParcialmentePago]: "Parcialmente Pago",
  [StatusComandaItem.Fechado]: "Fechado",
  [StatusComandaItem.Cancelado]: "Cancelado",
};

export function getStatusComandaItemDescricao(status) {
  return StatusComandaItemDescricao[status] ?? "Desconhecido";
}